"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_REQUIRED_VALIDATOR = exports.RequiredValidator = exports.NUMBER_REQUIRED_VALIDATOR = void 0;
var _core = require("@focaltec-suite/core");
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var RequiredValidator = exports.RequiredValidator = /*#__PURE__*/_createClass(function RequiredValidator(type) {
  var _this = this;
  _classCallCheck(this, RequiredValidator);
  this.isValid = function (value) {
    if (value === undefined && value === null) {
      return false;
    }
    switch (_this.type) {
      case 'number':
        return !isNaN(parseFloat("".concat(value)));
      default:
        return "".concat(value !== null && value !== void 0 ? value : '').trim().length > 0;
    }
  };
  this.getMessage = function () {
    return (0, _core.translate)('validations.required');
  };
  this.type = type;
});
var TEXT_REQUIRED_VALIDATOR = exports.TEXT_REQUIRED_VALIDATOR = new RequiredValidator('text');
var NUMBER_REQUIRED_VALIDATOR = exports.NUMBER_REQUIRED_VALIDATOR = new RequiredValidator('number');